import React, { forwardRef, useEffect, useImperativeHandle, useState } from "react";
import Male from "../Investment/Images/Group3635.svg";
import Female from "../Investment/Images/Group3639.svg";
import editDetails from "../Investment/Images/Group1510.svg";
import { CountYear, convertIntoLakh, CommaSeprator, calculateAge } from "./UtilityComponents/UtilityFunction";
import OutsideClickHandler from 'react-outside-click-handler';
import { Modal } from "react-bootstrap";
import EditSideDetails from "./EditSideDetails";
import CustomDropdown from "./UtilityComponents/CustomDropdown";
import { frequencyListInShort, paymentFrequencyList } from "./UtilityComponents/constant";

const InvestmentAddDetails = forwardRef((props, ref) => {
    //console.log(props?.QuoteReq, "email");
    const [IsOpenGetMoney, setIsOpenGetMoney] = useState(false);
    const [IsPlanType, setIsPlanType] = useState(false);
    const [IsOpenPayFreq, setIsOpenPayFreq] = useState(false);
    const [IsOpenInsurer, setIsOpenInsurer] = useState(false);
    const [IsOpenReturn, setIsOpenReturn] = useState(false);
    const [PlanName, setPlanName] = useState("LS");
    const [ModelPremium, setModelPremium] = useState("");
    const [PaymentFreq, setPaymentFreq] = useState('');
    const [IsEditSideDetails, setIsEditSideDetails] = useState(false);
    const [name, setName] = useState(props?.QuoteReq?.FullName);
    const [income, setIncome] = useState(props?.QuoteReq?.AnnualIncome);
    const [age, setAge] = useState(props?.QuoteReq?.Age);
    const [DOB, setDOB] = useState(props?.QuoteReq?.DOB);
    const [selected, setSelected] = useState([]);
    const [finalSelected, setFinalSelected] = useState([]);
    const [BtnDisabled, setBtnDisabled] = useState(false);
    const [isInsureBtnDisabled, setInsureBtnDisabled] = useState(true);
    const [error, setError] = useState({});
    const [PolicyTermListArr, setPolicyTermListArr] = useState([]);
    const [PaymentTermListArr, setPaymentTermListArr] = useState([]);
    const [IsShowPolicyTerm, setShowPolicyTerm] = useState(false);
    const [IsShowPaymentTerm, setShowPaymentTerm] = useState(false);

    const handlePremiumAndFreq = () => {
        let goto = true;
        let error = {};
        if (ModelPremium.trim() === '') {
            goto = false;
            error['ModelPremium'] = "Enter model premium amount";
        }
        setError(error);
        if (goto) {
            setIsOpenPayFreq(!IsOpenPayFreq);
            props.handlePremiumAndFreq(ModelPremium, PaymentFreq);
        }
    }
    useEffect(() => {
        const { PaymentFreq, ModelPremium } = props.QuoteReq;
        setPaymentFreq(PaymentFreq);
        setModelPremium(ModelPremium);
        setBtnDisabled(true);
        setPolicyTermListArr(getPayOrPolicyTermList("PolicyTerm"));
        setPaymentTermListArr(getPayOrPolicyTermList("PaymentTerm"));
    }, []);

    useEffect(() => {
        if (props?.QuoteReq?.InvestmentType === "ML") {
            setPolicyTermListArr(getPayOrPolicyTermList("PolicyTerm", "ML"));
            setPaymentTermListArr(getPayOrPolicyTermList("PaymentTerm", "ML"));
        } else {
            setPolicyTermListArr(getPayOrPolicyTermList("PolicyTerm"));
            setPaymentTermListArr(getPayOrPolicyTermList("PaymentTerm"));
        }
    }, [props?.QuoteReq?.InvestmentType]);

    useEffect(() => {
        const storedFullName = sessionStorage.getItem('FullName');
        if (storedFullName !== null && storedFullName !== "") {
            setName(storedFullName);
        }

        const storedIncome = sessionStorage.getItem('Income');
        if (storedIncome !== null && storedIncome !== "") {
            setIncome(storedIncome);
        }

        const storedDOB = sessionStorage.getItem('DOB');
        if (storedDOB !== null && storedDOB !== "") {
            setDOB(storedDOB);
        }

        const storedAge = sessionStorage.getItem('Age');
        if (storedAge !== null && storedAge !== "") {
            setAge(storedAge);
        }
    }, [])


    const getPayOrPolicyTermList = (param, isMarketList) => {
        let list = [];
        if (param == "PolicyTerm") {
            let maxLength = isMarketList == "ML" ? 82 : 40;
            for (let i = 5; i <= maxLength; i++) {
                list.push(i);
            }
            
        } else {
            let maxLength = isMarketList == "ML" ? 67 : 32;
            for (let i = 5; i <= maxLength; i++) {
                list.push(i);
            }
        }
        return list;
    }

    function onSubmitHandler({ FullName, DOB, AnnualIncome, MobileNo, Email, gender, IsSmoker, Age, Occupation, Education, isChildPlan,
        ChildName,
        ChildGender,
        ChildDOB }) {
        setName(FullName);
        setIncome(AnnualIncome);
        let age = Age;
        setDOB(DOB);
        setAge(age);

        props.UpdateResult({
            FullName, DOB, AnnualIncome, MobileNo, Email, Age: age, Gender: gender, IsSmoker, Occupation,Education, isChildPlan,
            ChildName,
            ChildGender,
            ChildDOB });
    }

    const plansSubmit = (data) => {
        props.plansGenerator(data);
    }


    const InvestmentType = props?.QuoteReq?.InvestmentType;

    const handleSelectInsurer = (e, item) => {
        setSelected(e.target.checked ? [...selected, item.InsurerId] : selected.filter(r => r !== item.InsurerId));
        setInsureBtnDisabled(false);
    }

    useEffect(() => {
        if (props.QuoteReq.SelectedInsurer) {
            const prevSelectedInsurer = props.QuoteReq.SelectedInsurer;
            if (prevSelectedInsurer.length === selected.length) {
                const isBothEqual = prevSelectedInsurer.some(item => selected.includes(item));
                setInsureBtnDisabled(isBothEqual);
            }

        }
        if (!props?.QuoteReq?.SelectedInsurer?.length && selected.length === 0) {
            setInsureBtnDisabled(true);
        }
    }, [props.QuoteReq.SelectedInsurer, selected]);

    const clearFilterQuote = () => {
        setSelected([]);
        setInsureBtnDisabled(false);
    }

    const submitInsurerPopup = () => {
        setIsOpenInsurer(false);
        setFinalSelected(selected);
        plansSubmit(selected);
        props.QuoteReq.SelectedInsurer = selected;
    }

    const handleModelPremium = (premValue) => {
        setModelPremium(premValue);
    }

    useEffect(() => {
        calculateModelPremiumRange();
    }, [ModelPremium, PaymentFreq]);

    const calculateModelPremiumRange = () => {
        const PremiumValue = parseInt(ModelPremium);
        const error = {};
        let goto = true;
        switch (PaymentFreq) {
            case "Y":
                if (PremiumValue < 6000 || PremiumValue > 3600000) {
                    error["ModelPremium"] = "Amount should be between 6,000 and 36,00,000 yearly";
                    setBtnDisabled(true);
                    goto = false;
                }
                break;

            case "Q":
                if (PremiumValue < 1500 || PremiumValue > 900000) {
                    error["ModelPremium"] = "Amount should be between 1,500 and 9,00,000 quarterly";
                    setBtnDisabled(true);
                    goto = false;
                }
                break;
            case "H":
                if (PremiumValue < 3000 || PremiumValue > 1800000) {
                    error["ModelPremium"] = "Amount should be between 3,000 and 18,00,000 half-yearly";
                    setBtnDisabled(true);
                    goto = false;
                }
                break;
            case "M":
                if (PremiumValue < 500 || PremiumValue > 300000) {
                    error["ModelPremium"] = "Amount should be between 500 and 3,00,000 monthly";
                    setBtnDisabled(true);
                    goto = false;
                }
                break;


            default:
                error['ModelPremium'] = "";
        }

        setError(error);
        if (goto) {
            setBtnDisabled(false);
        }
    }

    useImperativeHandle(ref, () => ({
        resetSelectedInsurerState: () => {
            setSelected([]);
            setFinalSelected([]);
        }
    }));


    const STAR = '*';

    // Har word ka pehla letter dikhega, baaki *: "Rahul Kumar" -> "R**** K****"
    const maskName = (value) =>
        String(value ?? '')
            .split(' ')
            .map((word) => (word ? word.charAt(0) + STAR.repeat(word.length - 1) : ''))
            .join(' ');

    return (
        <>

            <Modal show={IsOpenReturn} className="customeName">
                <div className="EditProduct">
                    <div className="EditProductHead">
                        <h1>Returns</h1>
                        <button className="clsBtn" onClick={() => setIsOpenReturn(false)}>
                            <img src={require("../Investment/Cross.svg").default} alt="" />
                        </button>
                    </div>

                    <div className="OpenGetMoney">
                        <label className="HLT_P_T_Box">
                            <input
                                type="radio"
                                id="ritemb"
                                name="ritem"
                                value="LS"
                                onChange={(e) => {
                                    props.getQuoteOnChange("PlanType", e.target.value);
                                    setPlanName(e.target.value);
                                    setIsOpenGetMoney(false);
                                }}
                            />
                            <span className="checkHLT_P_T_Box"></span>
                            At 4%
                            <small>IRDAI Mandate</small>
                        </label>

                        <label className="HLT_P_T_Box">
                            <input
                                type="radio"
                                id="ritema"
                                name="ritem"
                                value="LS"
                                checked={props?.QuoteReq?.PlanType === "LS" ? true : false}
                                onChange={(e) => {
                                    props.getQuoteOnChange("PlanType", e.target.value);
                                    setPlanName(e.target.value);
                                    setIsOpenGetMoney(false);
                                }}
                            />
                            <span className="checkHLT_P_T_Box"></span>
                            At 8%
                            <small>IRDAI Mandate</small>
                        </label>
                    </div>
                </div>
            </Modal>

            <Modal show={IsEditSideDetails} className="IsEditSideDetails">
                <EditSideDetails exit={() => setIsEditSideDetails(false)} IsSmoker={props.QuoteReq?.IsSmoker} EducationList={props.EducationList} OccupationList={props.OccupationList} QuoteReq={props.QuoteReq} name={name} mob={props?.QuoteReq?.MobileNo} DOB={DOB} Income={income} Gender={props?.QuoteReq?.Gender} onsubmit={onSubmitHandler} UpdateResult={props.UpdateResult} onDobChange={props.onDobChange} email={props?.QuoteReq?.Email} />
            </Modal>

            { }
            <div className="InvestmentQuoteTop">
                <div className="InvestBorder TopSpace">
                    <div className="InvesterDetails">
                        <div className="t-inputs">
                            {/*<div className="InvestHeading">
                                {" "}
                                {props?.QuoteReq?.Gender === "M" ? (
                                    <img src={Male} className="IconPic" alt="" />
                                ) : (
                                    <img src={Female} className="IconPic" alt="" />
                                )}{" "}
                                <span>{props?.QuoteReq?.Gender === "M" ? "Male" : "Female"}</span>
                                <p className="NameAge text-break"><span className="text-capitalize">{name}</span><span> | {age} Yrs</span> <span> | {props?.QuoteReq?.IsSmoker ? "Smoker" :"Non-Smoker"} </span>{" "}</p>
                                <p>Annual Income: <span>₹{convertIntoLakh(income)} {" "}</span></p>
                                {(props.QuoteReq.InvestmentType === "ML" && props.QuoteReq?.Occupation && props.QuoteReq?.Education ) && <p> <span>{props.OccupationList.find(item => item.Code == props.QuoteReq?.Occupation)?.MasterName} | Education: {props.EducationList.find(item => item.Code == props.QuoteReq?.Education)?.MasterName}</span></p>}
                            </div>*/}

                            <div className="InvestHeading">
                                {" "}
                                {props?.QuoteReq?.Gender === "M" ? (
                                    <img src={Male} className="IconPic" alt="" />
                                ) : (
                                    <img src={Female} className="IconPic" alt="" />
                                )}{" "}
                                <span>{props?.QuoteReq?.Gender === "M" ? "Male" : "Female"}</span>
                                <p className="NameAge text-break">
                                    <span className="text-capitalize">{maskName(name)}</span>
                                    <span> | {age} Yrs</span>
                                    <span> | {props?.QuoteReq?.IsSmoker ? "Smoker" : "Non-Smoker"} </span>{" "}
                                </p>
                                <p>Annual Income: <span>₹{convertIntoLakh(income)} {" "}</span></p>
                                {(props.QuoteReq.InvestmentType === "ML" && props.QuoteReq?.Occupation && props.QuoteReq?.Education) && (
                                    <p>
                                        <span>
                                            {props.OccupationList.find(item => item.Code == props.QuoteReq?.Occupation)?.MasterName} | Education: {props.EducationList.find(item => item.Code == props.QuoteReq?.Education)?.MasterName}
                                        </span>
                                    </p>
                                )}
                            </div>

                            {/*<div className="InvestHeading-Mobile">*/}
                            {/*    <p>{props?.QuoteReq?.Age} years, {props?.QuoteReq?.Gender === "M" ? "Male" : "Female"}, Annual Income: <span>?{convertIntoLakh(props?.QuoteReq?.AnnualIncome)} {" "}</span></p>*/}
                            {/*</div>*/}
                            <div className="EditVehicleDet">
                                <span onClick={() => setIsEditSideDetails(true)} className="InvestmentEditCust">
                                    <img src={editDetails} alt="" />
                                    Edit
                                </span>
                            </div>
                        </div>

                        {/* <div className="t-inputs">
                    <div className="labeltext">
                      <a onClick={() => setIsOpenReturn(!IsOpenReturn)}>
                        At 8%
                        <i class="fas fa-chevron-down"></i>
                      </a>
                    </div>
                    <label className="AllLabel">Returns</label>
                  </div> */}
                    </div>
                    <div className="InvesterDetailsFilter">

                        <div className="t-inputs">
                            <div className="labeltext">
                                <a onClick={() => (props.IsGuaranteed && props.IsParticipating) ? false : setIsPlanType(!IsPlanType)}>
                                    {InvestmentType === "GP" ? "100% Guaranteed" : InvestmentType === "ML" ? "Market Linked" : InvestmentType === "PP" ? "Participating" : ""}
                                    {props.IsGuaranteed ? false : <i class="fas fa-chevron-down"></i>}
                                </a>

                                <OutsideClickHandler onOutsideClick={() => setIsPlanType(false)}>
                                    <>
                                        {IsPlanType &&
                                            <div className="EditProduct">
                                                <div className="EditProductHead">
                                                    <h1>Select Plan Type </h1>
                                                    <button className="clsBtn" onClick={() => setIsPlanType(false)}>
                                                        <img src={require("../Investment/Cross.svg").default} alt="" />
                                                    </button>
                                                </div>

                                                <div className="OpenGetMoney">
                                                    <label className="HLT_P_T_Box">
                                                        <input
                                                            type="radio"
                                                            name="ritem"
                                                            value="GP"
                                                            checked={props?.QuoteReq?.InvestmentType === "GP"}
                                                            onChange={(e) => {
                                                                props.getQuoteOnChange("InvestmentType", e.target.value);
                                                                setIsPlanType(false);
                                                            }}
                                                        />
                                                        <span className="checkHLT_P_T_Box"></span>
                                                        <strong>100% Guaranteed</strong>
                                                    </label>
                                                    <label className="HLT_P_T_Box">
                                                        <input
                                                            type="radio"
                                                            name="ritem"
                                                            value="ML"
                                                            checked={props?.QuoteReq?.InvestmentType === "ML"}
                                                            onChange={(e) => {
                                                                props.getQuoteOnChange("InvestmentType", e.target.value);
                                                                setIsPlanType(false);
                                                            }}
                                                        />
                                                        <span className="checkHLT_P_T_Box"></span>
                                                        <strong>Market Linked</strong>
                                                    </label>
                                                    <label className="HLT_P_T_Box">
                                                        <input
                                                            type="radio"
                                                            name="ritem"
                                                            value="PP"
                                                            checked={props?.QuoteReq?.InvestmentType === "PP"}
                                                            onChange={(e) => {
                                                                props.getQuoteOnChange("InvestmentType", e.target.value);
                                                                setIsPlanType(false);
                                                            }}
                                                        />
                                                        <span className="checkHLT_P_T_Box"></span>
                                                        <strong>Participating</strong>
                                                    </label>
                                                </div>
                                            </div>
                                        }
                                    </>
                                </OutsideClickHandler>

                            </div>
                            <label className="AllLabel">Plan type</label>
                        </div>

                        {props.QuoteReq.InvestmentType !== "ML" &&
                            <div className="t-inputs">
                            <div className="labeltext">
                                <a onClick={() => setIsOpenGetMoney(!IsOpenGetMoney)}>
                                    {props?.QuoteReq?.PlanType === "LS" && true
                                        ? "Lumpsum"
                                        : props?.QuoteReq?.PlanType === "IIM" && true
                                            ? "Immediate Income"
                                            : props?.QuoteReq?.PlanType === "IST" && true
                                                ? "Income for Short Term"
                                                : props?.QuoteReq?.PlanType === "ILT" && true
                                                    ? "Income for Long Term" : ""}
                                    <i class="fas fa-chevron-down"></i>
                                </a>

                                <OutsideClickHandler onOutsideClick={() => setIsOpenGetMoney(false)}>
                                    {IsOpenGetMoney &&
                                        <div className="EditProduct GetMoneyAs">
                                            <div className="EditProductHead">
                                                <h1>Get money as </h1>
                                                <button className="clsBtn" onClick={() => setIsOpenGetMoney(false)}>
                                                    <img src={require("../Investment/Cross.svg").default} alt="" />
                                                </button>
                                            </div>

                                            <div className="OpenGetMoney">
                                                <label className="HLT_P_T_Box">
                                                    <input
                                                        type="radio"
                                                        id="ritemb"
                                                        name="ritem"
                                                        value="LS"
                                                        checked={props?.QuoteReq?.PlanType === "LS" ? true : false}
                                                        onChange={(e) => {
                                                            props.getQuoteOnChange("PlanType", e.target.value);
                                                            setPlanName(e.target.value);
                                                            setIsOpenGetMoney(false);
                                                        }}
                                                    />
                                                    <span className="checkHLT_P_T_Box"></span>
                                                    <strong>Lumpsum</strong>
                                                </label>
                                                <label className="HLT_P_T_Box">
                                                    <input
                                                        type="radio"
                                                        id="ritemb"
                                                        name="ritem"
                                                        value="IST"
                                                        checked={props?.QuoteReq?.PlanType === "IST" ? true : false}
                                                        onChange={(e) => {
                                                            props.getQuoteOnChange("PlanType", e.target.value);
                                                            setPlanName(e.target.value);
                                                            setIsOpenGetMoney(false);
                                                        }}
                                                    />
                                                    <span className="checkHLT_P_T_Box"></span>
                                                    <strong>Income for Short Term</strong>
                                                </label>
                                                <label className="HLT_P_T_Box">
                                                    <input
                                                        type="radio"
                                                        id="ritemb"
                                                        name="ritem"
                                                        value="ILT"
                                                        checked={props?.QuoteReq?.PlanType === "ILT" ? true : false}
                                                        onChange={(e) => {
                                                            props.getQuoteOnChange("PlanType", e.target.value);
                                                            setPlanName(e.target.value);
                                                            setIsOpenGetMoney(false);
                                                        }}
                                                    />
                                                    <span className="checkHLT_P_T_Box"></span>
                                                    <strong>Income for Long Term</strong>
                                                </label>
                                                <label className="HLT_P_T_Box">
                                                    <input
                                                        type="radio"
                                                        id="ritema"
                                                        name="ritem"
                                                        value="IIM"
                                                        checked={props?.QuoteReq?.PlanType === "IIM" ? true : false}
                                                        onChange={(e) => {
                                                            props.getQuoteOnChange("PlanType", e.target.value);
                                                            setPlanName(e.target.value);
                                                            setIsOpenGetMoney(false);
                                                        }}
                                                    />
                                                    <span className="checkHLT_P_T_Box"></span>
                                                    <strong>Immediate Income</strong>
                                                </label>
                                            </div>
                                        </div>
                                    }
                                </OutsideClickHandler>


                            </div>
                            <label className="AllLabel">Get money as</label>
                        </div>}
                       

                        <div className="t-inputs">
                            <div className="labeltext">
                                <a onClick={() => setIsOpenPayFreq(!IsOpenPayFreq)}>
                                    {props.QuoteReq.InvestmentType !== "ML" && <>₹ {CommaSeprator(props?.QuoteReq?.ModelPremium)} /{" "}</>}
                                    {props?.QuoteReq?.PaymentFreq === "Y"
                                        ? "Yearly"
                                        : props?.QuoteReq?.PaymentFreq === "M"
                                            ? "Monthly"
                                            : props?.QuoteReq?.PaymentFreq === "Q"
                                                ? "Quarterly"
                                                : props?.QuoteReq?.PaymentFreq === "H"
                                                    ? "Half Yearly"
                                                    : ""}
                                    <i class="fas fa-chevron-down"></i>
                                </a>
                            </div>
                            <label className="AllLabel">Wish to pay</label>

                            <OutsideClickHandler onOutsideClick={() => setIsOpenPayFreq(false)}>
                                <>
                                    {IsOpenPayFreq && (
                                        <div className="OpenPayFreqMai">

                                            <div className="OpenPayFreqHead">
                                                <h1>Wish to pay</h1>
                                                <button className="clsBtn" onClick={() => setIsOpenPayFreq(!IsOpenPayFreq)}>
                                                    <img src={require("../Investment/Cross.svg").default} alt="" />
                                                </button>
                                            </div>

                                            
                                                < div className="OpenPayFreq">
                                                    {props.QuoteReq.InvestmentType !== "ML" &&
                                                        <div className="t-inputs">
                                                    <input
                                                        type="text"
                                                        className="InvestSelect"
                                                        value={`₹ ${CommaSeprator(ModelPremium)}`} // Add comma separator
                                                        onChange={(e) => {
                                                            const numericValue = e.target.value.replace(/\D/g, ''); // Remove non-numeric characters
                                                            if (numericValue.length <= 8) { // Check for 9-digit limit
                                                                handleModelPremium(numericValue);
                                                            }
                                                        }}
                                                    />
                                                    {/* <span className="Error-Text">{error.ModelPremium}</span>*/}
                                                    <label className="AllLabel">Investment amount</label>
                                                </div>}
                                                <div className={`t-inputs  ${props.QuoteReq.InvestmentType == "ML" ?"inputs22":""}`}>
                                                    {/*<select
                                                        className="InvestSelect"
                                                        defaultValue={PaymentFreq}
                                                        onChange={(e) => setPaymentFreq(e.target.value)}
                                                        disabled={props?.QuoteReq?.PaymentTerm==1}
                                                    >
                                                        <option value="Y">Yearly</option>
                                                        <option value="M">Monthly</option>
                                                        <option value="Q">Quarterly</option>
                                                        <option value="H">Half Yearly</option>
                                                    </select>*/}
                                                    <CustomDropdown
                                                        options={frequencyListInShort}
                                                        value={PaymentFreq}
                                                        labelKey="name"
                                                        valueKey="code"
                                                        isSearchable={false}
                                                        onChange={(data) => setPaymentFreq(data.code)}
                                                        disabled={props?.QuoteReq?.PaymentTerm == 1}

                                                    />
                                                    {/*<i class="fas fa-chevron-down"></i>*/}
                                                    <label className="AllLabel">Payment frequency</label>
                                                </div>
                                            </div>

                                           
                                             {/*   <div className="OpenPayFreq">
                                                <div className="t-inputs inputs22">
                                                    <select
                                                        className="InvestSelect"
                                                        defaultValue={PaymentFreq}
                                                        onChange={(e) => setPaymentFreq(e.target.value)}
                                                        disabled={props?.QuoteReq?.PaymentTerm == 1}
                                                    >
                                                        <option value="Y">Yearly</option>
                                                        <option value="M">Monthly</option>
                                                        <option value="Q">Quarterly</option>
                                                        <option value="H">Half Yearly</option>
                                                    </select>
                                                    <i class="fas fa-chevron-down"></i>
                                                    <label className="AllLabel">Payment frequency</label>
                                                </div>
                                            </div>*/}

                                            <p className="Error-Text px-3">{error.ModelPremium}</p>
                                            <div className="OpenPayFreq Buttons">
                                                <div className="t-inputs">
                                                    <button
                                                        class="CancelBTN"
                                                        onClick={() => setIsOpenPayFreq(!IsOpenPayFreq)}
                                                    >
                                                        Cancel
                                                    </button>
                                                </div>
                                                <div className="t-inputs">
                                                    <button
                                                        class={BtnDisabled ? "BtnDisabled" : "BtnEnabled"}
                                                        disabled={BtnDisabled}
                                                        onClick={() => {

                                                            handlePremiumAndFreq();
                                                        }}
                                                    >
                                                        Okay
                                                    </button>
                                                </div>

                                            </div>
                                        </div>
                                    )}
                                </>
                            </OutsideClickHandler>

                        </div>
                        {/*<div className="t-inputs">
                            <div className="labeltext">
                                <select
                                    className="InvestSelect"
                                    value={props?.QuoteReq?.PaymentTerm}
                                    onChange={(e) => {
                                        props.getQuoteOnChange("PaymentTerm", e.target.value);
                                    }
                                    }
                                >
                                    <option value="1">Single Pay</option>
                                   
                                </select>
                                <i class="fas fa-chevron-down"></i>
                            </div>
                            <label className="AllLabel">Pay for</label>
                            <div className="DateTicks">
                                {" "}
                                till {CountYear(props?.QuoteReq?.PaymentTerm)}
                            </div>
                        </div>*/}

                        <div className="t-inputs">
                            <div className="labeltext">
                                <a onClick={() => setShowPaymentTerm(!IsShowPaymentTerm)}>
                                    {props?.QuoteReq?.PaymentTerm == "1" ? "Single Pay" : props?.QuoteReq?.PaymentTerm +" years" }
                                    <i class="fas fa-chevron-down"></i>
                                </a>

                                <OutsideClickHandler onOutsideClick={() => setShowPaymentTerm(false)}>
                                    <>
                                        {IsShowPaymentTerm &&
                                            <div className="EditProduct GetMoneyAs">
                                                <div className="EditProductHead">
                                                    <h1>Select Payment Term </h1>
                                                    <button className="clsBtn" onClick={() => setShowPaymentTerm(false)}>
                                                        <img src={require("../Investment/Cross.svg").default} alt="" />
                                                    </button>
                                                </div>

                                                <div className="OpenGetMoney">
                                                    <>
                                                        <label className="HLT_P_T_Box">
                                                            <input
                                                                type="radio"
                                                                name="ritem"
                                                                value="1"
                                                                checked={props?.QuoteReq?.PaymentTerm == "1"}
                                                                onChange={(e) => { setShowPaymentTerm(false); props.getQuoteOnChange("PaymentTerm", e.target.value) }}
                                                            />
                                                            <span className="checkHLT_P_T_Box"></span>
                                                            <strong>Single Pay</strong>
                                                        </label>

                                                        {PaymentTermListArr?.map((payterm) => (
                                                                <label className="HLT_P_T_Box">
                                                                    <input
                                                                        type="radio"
                                                                        name="ritem"
                                                                        value={payterm}
                                                                        checked={props?.QuoteReq?.PaymentTerm == payterm}
                                                                    onChange={(e) => { setShowPaymentTerm(false); props.getQuoteOnChange("PaymentTerm", e.target.value) }}
                                                                    />
                                                                    <span className="checkHLT_P_T_Box"></span>
                                                                    <strong>{payterm} years</strong>
                                                            </label>
                                                        ))}
                                                        </>
                                                </div>
                                            </div>
                                        }
                                    </>
                                </OutsideClickHandler>
                            </div>
                            <label className="AllLabel">Pay For</label>
                            <div className="DateTicks">
                                on {CountYear(props?.QuoteReq?.PaymentTerm)}
                            </div>
                        </div>



                        <div className="t-inputs">
                            <div className="labeltext">
                                <a onClick={() => setShowPolicyTerm(!IsShowPolicyTerm)}>
                                    {props?.QuoteReq?.PolicyTerm +" years"}
                                    <i class="fas fa-chevron-down"></i>
                                </a>
                                <OutsideClickHandler onOutsideClick={() => setShowPolicyTerm(false)}>
                                    <>
                                        {IsShowPolicyTerm &&
                                            <div className="EditProduct GetMoneyAs">
                                                <div className="EditProductHead">
                                                    <h1>Select Maturity  </h1>
                                                    <button className="clsBtn" onClick={() => setShowPolicyTerm(false)}>
                                                        <img src={require("../Investment/Cross.svg").default} alt="" />
                                                    </button>
                                                </div>

                                                <div className="OpenGetMoney">
                                                    {props?.QuoteReq?.PlanType === "IIM" && props?.QuoteReq?.InvestmentType === "PP" ?
                                                        <>
                                                            <label className="HLT_P_T_Box">
                                                                <input
                                                                    type="radio"
                                                                    name="ritem"
                                                                    value="80"
                                                                    checked={props?.QuoteReq?.PolicyTerm == "80"}
                                                                    onChange={(e) => { setShowPolicyTerm(false); props.getQuoteOnChange("PolicyTerm", e.target.value) }}
                                                                />
                                                                <span className="checkHLT_P_T_Box"></span>
                                                                <strong>80 years</strong>
                                                            </label>
                                                            <label className="HLT_P_T_Box">
                                                                <input
                                                                    type="radio"
                                                                    name="ritem"
                                                                    value="100"
                                                                    checked={props?.QuoteReq?.PolicyTerm == "100"}
                                                                    onChange={(e) => { setShowPolicyTerm(false); props.getQuoteOnChange("PolicyTerm", e.target.value) }}
                                                                />
                                                                <span className="checkHLT_P_T_Box"></span>
                                                                <strong>100 years</strong>
                                                            </label>
                                                        </>
                                                        : <>
                                                            {PolicyTermListArr?.map((ptVal) => (
                                                                ptVal >= props?.QuoteReq?.PaymentTerm && <label className="HLT_P_T_Box">
                                                                    <input
                                                                        type="radio"
                                                                        name="ritem"
                                                                        value={ptVal}
                                                                        checked={props?.QuoteReq?.PolicyTerm == ptVal}
                                                                        onChange={(e) => { setShowPolicyTerm(false); props.getQuoteOnChange("PolicyTerm", e.target.value) }}
                                                                    />
                                                                    <span className="checkHLT_P_T_Box"></span>
                                                                    <strong>{ptVal} years</strong>
                                                                </label>))}
                                                        </>}
                                                </div>
                                            </div>
                                        }
                                    </>
                                </OutsideClickHandler>
                            </div>
                            <label className="AllLabel">Maturity after</label>
                            <div className="DateTicks">
                                on {CountYear(props?.QuoteReq?.PolicyTerm)}
                            </div>
                        </div>





                        <div className="t-inputs">
                            <div className="labeltext">
                                <a style={{ cursor: props.AllQuotes.length <= 1 ? "auto" : "pointer", color: props.AllQuotes.length <= 1 ? "#dad5d5" :"#1d1d1d" }} onClick={() => setIsOpenInsurer(props.AllQuotes.length <= 1 ? false : true)}>
                         
                                    {finalSelected.length > 0 ? `${props?.InsurerList.find(r => r.Key === finalSelected[0])?.Value.split(" ").slice(0, 2).join(" ")}` + (finalSelected.length > 1 ? ` & ${finalSelected.length - 1} More` : "") : "Filter Insurers"}
                                    {/*{selected.length > 0 ? `${props?.res.find(r => r.InsurerId === selected[0])?.PlanName.split(" ").slice(0, 2).join(" ")}` + (selected.length > 1 ? ` & ${selected.length - 1} More` : "") : "Filter Insurers"}*/}
                                    <i class="fas fa-chevron-down"></i>
                                </a>

                                <OutsideClickHandler onOutsideClick={() => setIsOpenInsurer(false)}>
                                    <>
                                        {IsOpenInsurer &&
                                            <div className="EditProduct SelectInsurer">
                                                <div className="EditProductHead">
                                                    <h1>Select Insurer </h1>
                                                    <button className="clsBtn" onClick={() => setIsOpenInsurer(false)}>
                                                        <img src={require("../Investment/Cross.svg").default} alt="" />
                                                    </button>
                                                </div>

                                                <div className="OpenGetMoney">
                                                    <div className="CompareBox SelectInsurer">
                                                        {props?.res?.map((item) => (
                                                            <label className="HLT_P_T_Box CompareCheck SelectInsurer" key={item}>
                                                                <input
                                                                    className="checkCompare ng-pristine ng-untouched ng-valid ng-empty SelectInsurer"
                                                                    id={item}
                                                                    name="ritem"
                                                                    value={item.PlanName}
                                                                    type="checkbox"
                                                                    checked={selected.includes(item.InsurerId)}
                                                                    onClick={(e) => handleSelectInsurer(e, item)}
                                                                />
                                                                {/*akanksha*/}
                                                                {props.InsurerList.filter((i) => i.Key === item.InsurerId)[0].Value.split(" ").slice(0, 1).join(" ")}
                                                                {/*{item.InsurerId}*/}
                                                                <span className="checkmarkCom SelectInsurer"></span>
                                                                {props.res?.filter(r => r.InsurerId === item.InsurerId)[0].Value}
                                                            </label>
                                                        ))}
                                                    </div>
                                                </div>

                                                <div className="OpenPayFreq SelectInsurer">
                                                    <div className="t-inputs">
                                                        <button class="CancelBTN" disabled={selected.length===0} onClick={() => clearFilterQuote()}>
                                                            Clear
                                                        </button>
                                                    </div>
                                                    <div className="t-inputs">
                                                        <button
                                                            class={isInsureBtnDisabled ? "BtnDisabled" : "BtnEnabled"}
                                                            disabled={isInsureBtnDisabled}
                                                            onClick={() => submitInsurerPopup()}>
                                                            Submit
                                                        </button>
                                                    </div>
                                                </div>
                                            </div>
                                        }
                                    </>
                                </OutsideClickHandler>

                            </div>
                            <label className="AllLabel">Select Insurer</label>
                        </div>
                    </div>
                </div>
               {/* <div className="d-flex justify-content-end">
                    <button className="calculatePremiumBtn" disabled={props.isSubmitDisabled} onClick={props.onSubmit}>Calculate Premium</button>
                </div>*/}
            </div>
        </>
    );
});

export default InvestmentAddDetails;
